import {
  Component,
  OnInit,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { Observable, Subscription } from "rxjs";

@Component({
  selector:
    "app-ark-container[future][loadingTemplate][successTemplate][errorTemplate][failureTemplate]",
  templateUrl: "./ark-container.component.html",
  styleUrls: ["./ark-container.component.scss"],
})
export class ArkContainerComponent<T> implements OnInit {
  @Input()
  future: Observable<T>;
  @Input()
  titleTemplate: TemplateRef<any>;
  @Input()
  loadingTemplate: TemplateRef<any>;
  @Input()
  successTemplate: TemplateRef<any>;
  @Input()
  failureTemplate: TemplateRef<any>;
  @Input()
  errorTemplate: TemplateRef<any>;
  @Output() onSuccess: EventEmitter<[T]> = new EventEmitter();
  @Output() onFailure: EventEmitter<any> = new EventEmitter();
  @Output() onError: EventEmitter<any> = new EventEmitter();
  currentTemplate: TemplateRef<any>;

  ngOnInit() {
    this.letTheMagicBegin();
  }

  letTheMagicBegin() {
    this.currentTemplate = this.loadingTemplate;
    let subs: Subscription = null;
    try {
      subs = this.future.subscribe(
        (data: any) => {
          if (data.status && data.status === "error") {
            this.currentTemplate = this.failureTemplate;
            this.onFailure.emit([data]);
          } else {
            this.currentTemplate = this.successTemplate;
            this.onSuccess.emit([data]);
          }
          if (subs) {
            subs.unsubscribe();
          }
        },
        (err) => {
          console.error(err);
          this.currentTemplate = this.failureTemplate;
          this.onFailure.emit([err]);
          if (subs) {
            subs.unsubscribe();
          }
        },
      );
    } catch (ex) {
      this.currentTemplate = this.errorTemplate;
      this.onError.emit([ex]);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.future && !changes.future.firstChange) {
      this.letTheMagicBegin();
    }
  }
}
